import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'


export class OptionWithData extends Component {
  static propTypes = {
    value: PropTypes.string.isRequired,
    forField: PropTypes.string.isRequired,
    searchKey: PropTypes.string.isRequired,
    appendString: PropTypes.string
  }

  state = {
    refetch: false
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.data.error && this.props.data.error && !this.state.refetch) {
      this.setState(
        { refetch: true },
        this.props.data.refetch()
      )
    }

    if (this.state.refetch) {
      this.setState({ refetch: false })
    }
  }

  getLabelValue(optionsData, searchKey) {
    if (searchKey === null)
      return ''

    const matchingValue = optionsData.find(option => (
      option.name.toLowerCase() === searchKey.toLowerCase()
    ))

    return matchingValue
      ? matchingValue.description
      : ''
  }

  render() {
    const { value, searchKey, appendString, data } = this.props

    if (data.loading || data.error) {
      return <option></option>
    }

    let labelValue = this.getLabelValue(data.__type.enumValues, searchKey)

    return <option value={value}>{`${labelValue}${appendString}`}</option>
  }
}

const getOptions = gql`
  query($name: String!) {
    __type(name: $name) {
      name
      kind
      enumValues {
        name
        description
      }
    }
  }
`

const withData =
  graphql(getOptions, {
    options: ({ forField, searchKey }) => ({
      variables: {
        name: forField
      }
    })
  })

export default withData(OptionWithData)



// WEBPACK FOOTER //
// ./src/components/option-with-data/index.js